import { render, staticRenderFns } from "./events-organization-tab.vue?vue&type=template&id=669d6250&"
import script from "./events-organization-tab.vue?vue&type=script&lang=js&"
export * from "./events-organization-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports